import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IEmailAction } from '../types/Action/IEmailAction';
import { IStaff } from '../types/IStaff';

const initialState: { ticketId: number, email: IEmailAction, originalNote: string, translateOption: number } = {
    ticketId: 0,
    email: {
        HTML_Note: '<p></p>',
        Billable_Time: 0,
        Non_Billable_Time: 0
    } as IEmailAction,
    originalNote: '',
    translateOption: 0
};

const emailActionSlice = createSlice({
    name: 'emailAction',
    initialState,
    reducers: {
        setNotes(state, action: PayloadAction<string>) {
            state.email.HTML_Note = action.payload;
        },
        setOriginalNote(state, action: PayloadAction<string>) {
            state.originalNote = action.payload;
        },
        setTranslationOption(state, action: PayloadAction<number>) {
            state.translateOption = action.payload;
        },
        setFrom(state, action: PayloadAction<string>) {
            state.email.From = action.payload;
        },
        setTo(state, action: PayloadAction<IStaff[]>) {
            state.email.To = action.payload;
        },
        setCC(state, action: PayloadAction<IStaff[]>) {
            state.email.CC = action.payload;
        },
        setShowCC(state, action: PayloadAction<boolean>) {
            state.email.Show_CC = action.payload;
        },
        setShowBCC(state, action: PayloadAction<boolean>) {
            state.email.Show_BCC = action.payload;
        },
        setBCC(state, action: PayloadAction<IStaff[]>) {
            state.email.BCC = action.payload;
        },
        setSubject(state, action: PayloadAction<string>) {
            state.email.Subject = action.payload;
        },
        setBillable(state, action: PayloadAction<number>) {
            state.email.Billable_Time = action.payload;
        },
        setNonBillable(state, action: PayloadAction<number>) {
            state.email.Non_Billable_Time = action.payload;
        },
        setTicketId(state, action: PayloadAction<number>) {
            state.ticketId = action.payload;
        },
        setTemplateId(state, action: PayloadAction<number>) {
            state.email.Template_Id = action.payload;
        },
        resetForm(state, action: PayloadAction<IEmailAction>) {
            // Reset the form to the initial state
            state.email = action.payload;
        },
    },
});

export const { setNotes, setFrom, setTo, setCC, setBCC, setSubject, setBillable, setNonBillable, resetForm, setShowCC, setShowBCC, setTicketId, setTemplateId, setOriginalNote, setTranslationOption } = emailActionSlice.actions;

export default emailActionSlice.reducer;